__turbopack_context__.v({
  "chevron-right-icon": "ChevronRight-module-scss-module__n7-5ia__chevron-right-icon",
});
